exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-bd4fa69a] {\n  margin: 0;\n  padding: 0;\n}\nh1[data-v-bd4fa69a],\nh2[data-v-bd4fa69a] {\n  font-weight: normal;\n}\nul[data-v-bd4fa69a] {\n  list-style-type: none;\n  padding: 0;\n}\nli[data-v-bd4fa69a] {\n  display: inline-block;\n  margin: 0 10px;\n}\na[data-v-bd4fa69a] {\n  color: #42b983;\n}\n.risk-box[data-v-bd4fa69a] {\n  float: left !important;\n}\n@media screen and (min-width: 600px) and (max-width: 1024px) {\n.gmnClass[data-v-bd4fa69a] {\n    width: 11rem !important;\n}\n.ItemClass[data-v-bd4fa69a] {\n    width: 11rem !important;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bd4fa69a","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Symp_itemIpad.vue
// module id = 0tff
// module chunks = 1